export default __webpack_public_path__ + "static/media/bounce.d005bbb0.png";